<template>
    <div class="main-content">
        <the-header title="Settings"></the-header>
    </div>
</template>

<script>
    import TheHeader from '../../admin/Layout/TheHeader'

    export default {
        components: {TheHeader},
        data() {
            return {

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/Settings.vue